/*
  svnty-exchange-session.js — THE EXCHANGE SHOP-BACK SESSION (Part8 P2, 2026-08-24)
  Spec: 02_architecture/svnty-exchange-shopback-spec-2026-08-24.md

  PII-free exchange session v2. The cart is never read or mutated. An explicit PDP or quick-shop
  choice records a non-authoritative target under a per-tab session ID. The returns desk repeats
  order, eligibility, line, price, and stock checks before native contact-form submission.

  LOADING (P0-1, RULED 2026-09-26): the returns page loads this file itself; every other page gets it from the
  bootstrap in layout/theme.liquid, and only while this tab carries a valid exchange session. Off the page it draws the
  swap bar, relabels the add buttons, captures the product form, and GUARDS THE BAG: while a swap is being chosen, every
  POST to /cart/add (the card's size row, the quick add door, the buy popup, the sticky bar, the wishlist's bag, Trade's
  product form) becomes the exchange choice and never reaches the cart. The page still keeps the whole choice in place (the
  rail and the in-page search); this is the net for a customer who wanders into the store mid-exchange.
  Nothing below may depend on DOMContentLoaded having yet to fire.
*/
(function () {
  'use strict';
  if (window.__svntyXsInit) return;
  window.__svntyXsInit = true;
  var ACTIVE_KEY = 'svnty:xs:active:v2';
  var PREFIX = 'svnty:xs:v2:';
  var LEGACY_KEY = 'svnty:xs:v2';
  var IDLE_MS = 30 * 60 * 1000;
  var HARD_MS = 24 * 60 * 60 * 1000;
  try {
    localStorage.removeItem('svnty:xs:v1'); // v1 carried PII; purge it everywhere
    localStorage.removeItem(LEGACY_KEY);    // v2's old global record was shared across tabs
  } catch (e) {}
  var DESK = '/pages/returns-exchanges';
  var isDesk = location.pathname.indexOf(DESK) === 0;

  function now() { return Date.now(); }
  function activeId() {
    try { return sessionStorage.getItem(ACTIVE_KEY) || ''; } catch (e) { return ''; }
  }
  function keyFor(id) { return PREFIX + id; }
  function newId() {
    var bytes = new Uint8Array(12);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    return 'xs_' + Array.prototype.map.call(bytes, function (byte) {
      var hex = byte.toString(16); return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }
  function emitStorageFailure() {
    var event;
    try { event = new CustomEvent('svnty:xs-storage-failed'); }
    catch (e) { event = document.createEvent('Event'); event.initEvent('svnty:xs-storage-failed', true, false); }
    document.dispatchEvent(event);
  }
  function validHandle(value) { return /^[a-z0-9][a-z0-9-]{0,254}$/.test(String(value || '')); }
  function validText(value, max) { return typeof value === 'string' && value.length <= max; }
  function validProductUrl(value) {
    if (!validText(value, 1000)) return false;
    try {
      var url = new URL(value, location.origin);
      return url.origin === location.origin && /^\/products\//.test(url.pathname);
    } catch (e) { return false; }
  }
  function validAssetUrl(value) {
    if (value === '') return true;
    if (!validText(value, 2000)) return false;
    try { var url = new URL(value, location.origin); return url.origin === location.origin || url.protocol === 'https:'; }
    catch (e) { return false; }
  }
  function validItem(item) {
    return !!item && validHandle(item.handle) && validText(item.title, 500) &&
      item.title.length > 0 && validProductUrl(item.url);
  }
  function validHave(have) {
    return !!have && validText(have.options, 500) && have.options.length > 0 &&
      Number.isFinite(Number(have.variant_id)) && Number(have.variant_id) > 0 &&
      (have.price == null || Number.isFinite(Number(have.price)));
  }
  function validTarget(target) {
    return target == null || (
      Number.isFinite(Number(target.variant_id)) && Number(target.variant_id) > 0 &&
      validHandle(target.handle) && validText(target.title, 500) && target.title.length > 0 &&
      validText(target.options || '', 500) && validAssetUrl(target.image || '') &&
      target.world === 'original' &&
      (target.product_id == null || (Number.isFinite(Number(target.product_id)) && Number(target.product_id) > 0)) &&
      (target.available == null || typeof target.available === 'boolean') &&
      (target.price == null || Number.isFinite(Number(target.price))) &&
      Number.isFinite(Number(target.captured_at))
    );
  }
  function valid(xs) {
    var created = Number(xs && xs.created), expires = Number(xs && xs.expires), rev = Number(xs && xs.rev);
    return !!xs && xs.v === 2 && /^xs_[0-9a-f]{24}$/.test(String(xs.id || '')) &&
      Number.isFinite(created) && Number.isFinite(expires) && created <= now() + 60000 &&
      expires >= created && expires <= created + HARD_MS &&
      Number.isInteger(rev) && rev >= 0 &&
      (xs.step === 'browsing' || xs.step === 'captured') &&
      validText(xs.binding, 500) && xs.binding.length > 0 &&
      validItem(xs.item) && validHave(xs.have) && validText(xs.reason || '', 500) &&
      xs.world === 'original' && validTarget(xs.target) &&
      (xs.step !== 'captured' || !!xs.target);
  }
  function read(id) {
    if (!id) return null;
    try { return JSON.parse(localStorage.getItem(keyFor(id))); } catch (e) { return null; }
  }
  function get() {
    var id = activeId();
    var xs = read(id);
    if (!valid(xs) || xs.id !== id || xs.expires < now() || xs.created + HARD_MS < now()) {
      clear(id);
      return null;
    }
    return xs;
  }
  function set(xs, expectedRev) {
    if (!xs || !/^xs_[0-9a-f]{24}$/.test(String(xs.id || ''))) return false;
    var current = read(xs.id);
    if (current && !valid(current)) return false;
    var expected = expectedRev == null ? Number(xs.rev) : Number(expectedRev);
    if (current && Number(current.rev) !== expected) return false;
    var next = JSON.parse(JSON.stringify(xs));
    next.rev = (current ? Number(current.rev) : Number(next.rev)) + 1;
    next.expires = Math.min(now() + IDLE_MS, Number(next.created) + HARD_MS);
    if (!valid(next)) return false;
    try {
      localStorage.setItem(keyFor(next.id), JSON.stringify(next));
      sessionStorage.setItem(ACTIVE_KEY, next.id);
      xs.rev = next.rev;
      xs.expires = next.expires;
      return true;
    } catch (e) { emitStorageFailure(); return false; }
  }
  function clear(id) {
    var target = id || activeId();
    try {
      if (target) localStorage.removeItem(keyFor(target));
      if (activeId() === target) sessionStorage.removeItem(ACTIVE_KEY);
    } catch (e) {}
  }
  function isActiveStorageKey(key) {
    var id = activeId();
    return !!id && key === keyFor(id);
  }
  window.SVNTYXs = {
    get: get,
    set: set,
    clear: clear,
    newId: newId,
    activeId: activeId,
    isActiveStorageKey: isActiveStorageKey,
    ACTIVE_KEY: ACTIVE_KEY,
    PREFIX: PREFIX
  };
  /* LIVE product truth: Section Rendering API first (works everywhere), /products/<handle>.js second.
     THE WALL (Part30, fixer W5-C). Neither read had a deadline, and this promise is what the returns desk
     awaits on leg 2 of its submit chain - with the form already `inert`. A read that never settled left her
     unable to click, tab or type until she reloaded the page. Both hops now carry the house wall
     (assets/svnty-wall.js): the abort rejects, and every caller's existing catch already says its own words.
     A caller with its own controller passes `signal` and keeps it; the wall then arms nothing of its own. */
  var PRODUCT_TIMEOUT = 8000;
  function wall(opts, ms) { return window.svntyWall ? window.svntyWall(opts, ms) : function () {}; }
  function fetchProduct(handle, signal) {
    var h = encodeURIComponent(handle);
    var a = { headers: { Accept: 'text/html' }, cache: 'no-store' };
    var b = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (signal) { a.signal = signal; b.signal = signal; }
    var doneA = wall(a, PRODUCT_TIMEOUT);
    return fetch('/products/' + h + '?section_id=svnty-product-json', a)
      .then(function (r) { doneA(); return r.ok ? r.text() : Promise.reject(r); }, function (e) { doneA(); throw e; })
      .then(function (html) {
        var m = /<script[^>]*data-svnty-product-json[^>]*>([\s\S]*?)<\/script>/.exec(html);
        if (!m) throw new Error('no json');
        return JSON.parse(m[1]);
      })
      .catch(function () {
        var doneB = wall(b, PRODUCT_TIMEOUT);   // the fallback hop gets its own wall: two hops, two deadlines
        return fetch('/products/' + h + '.js', b)
          .then(function (r) { doneB(); return r.ok ? r.json() : Promise.reject(r); }, function (e) { doneB(); throw e; });
      });
  }
  window.SVNTYXs.fetchProduct = fetchProduct;

  if (isDesk) return;                  // the desk script owns its own page
  var xs = get();
  if (xs) set(xs, xs.rev);             // slide the idle clock on every page view

  /* ---------- THE BAG GUARD (P0-1): the one choke point every add path shares is fetch ----------
     While the session is browsing, a POST to /cart/add is answered here, never sent: the variant it carries becomes the exchange
     choice (the same capture as the product form), and the caller receives Shopify's own refusal shape (status 422, message and
     description) saying the truth, so any add path's error words read "Chosen for your exchange. Nothing was added to your bag."
     Every other request passes through untouched. */
  var realFetch = window.fetch;
  function variantOf(body) {
    try {
      if (!body) return '';
      if (typeof FormData === 'function' && body instanceof FormData) return String(body.get('id') || body.get('items[0][id]') || '');
      if (typeof URLSearchParams === 'function' && body instanceof URLSearchParams) return String(body.get('id') || body.get('items[0][id]') || '');
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{') { var j = JSON.parse(t); return String(j.id || (j.items && j.items[0] && j.items[0].id) || ''); }
        var u = new URLSearchParams(t); return String(u.get('id') || u.get('items[0][id]') || '');
      }
    } catch (e) {}
    return '';
  }
  function isCartAdd(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    return method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(/^https?:\/\/[^\/]+/, ''));
  }
  if (typeof realFetch === 'function' && !realFetch.__svntyXs) {
    var guarded = function (input, init) {
      var x = get();
      if (x && x.step === 'browsing' && isCartAdd(input, init)) {
        var vid = variantOf(init && init.body);
        if (vid && /^\d+$/.test(vid)) captureVariant(vid, '');
        var said = vid ? 'Chosen for your exchange. Nothing was added to your bag.' : 'You are choosing an exchange. Nothing was added to your bag.';
        return Promise.resolve(new Response(JSON.stringify({ status: 422, message: said, description: said }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }));
      }
      return realFetch.apply(window, arguments);
    };
    guarded.__svntyXs = true;
    window.fetch = guarded;
  }

  /* ---------- swap bar ---------- */
  var css = '.svnty-xs-bar{position:fixed;inset-inline:0;inset-block-end:0;z-index:60;transform:translateY(calc(-1 * var(--svp-xs-dock, 0px)));will-change:transform;transition:transform var(--svp-xs-dock-dur, .32s) var(--svp-xs-dock-ease, cubic-bezier(.2,.7,.2,1));display:flex;align-items:center;gap:12px;padding:10px 16px;padding-block-end:max(10px,env(safe-area-inset-bottom));background:var(--svp-fg);color:var(--svp-bg);font-family:var(--svp-font-body);font-size:1.3rem;line-height:1.35;border-radius:0}' +
    '.svnty-xs-bar__text{flex:1 1 auto;min-inline-size:0}.svnty-xs-bar__text strong{font-weight:600}' +
    '.svnty-xs-bar__act{flex:0 1 auto;max-inline-size:48%;min-block-size:44px;display:inline-flex;align-items:center;justify-content:center;text-align:center;padding:8px 12px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;font-size:1.1rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;cursor:pointer;border-radius:var(--svnty-r-control,4px)}' +
    '.svnty-xs-bar__act--solid{background:var(--svp-bg);color:var(--svp-fg)}' +
    'body.svnty-xs-live{padding-block-end:64px}body.svnty-xs-live.svnty-has-pdpbar{padding-block-end:calc(var(--svp-pdpbar-h,96px) + env(safe-area-inset-bottom,0px) + 8px + 64px)}' +
    '.svnty-xs-toast{position:fixed;inset-inline:16px;inset-block-end:calc(72px + var(--svp-xs-dock, 0px) + env(safe-area-inset-bottom));z-index:61;margin-inline:auto;max-inline-size:420px;display:flex;align-items:center;gap:12px;padding:14px 16px;border:1px solid rgb(0 0 0 / .08);background:rgb(255 255 255 / .74);-webkit-backdrop-filter:blur(18px) saturate(1.5);backdrop-filter:blur(18px) saturate(1.5);color:#000;font-family:var(--svp-font-body);font-size:1.3rem;line-height:1.35;border-radius:var(--svnty-r-container,8px);box-shadow:0 8px 32px rgb(0 0 0 / .12);opacity:0;transform:translateY(16px);pointer-events:none;transition:opacity .22s ease-out,transform .26s cubic-bezier(.2,.7,.2,1)}' +
    '.svnty-xs-toast.is-in{opacity:1;transform:translateY(0)}.svnty-xs-toast.is-out{opacity:0;transform:translateY(6px);transition:opacity .28s ease-in,transform .28s ease-in}' +
    '.svnty-xs-toast__check{flex:0 0 28px;inline-size:28px;block-size:28px;border-radius:50%;display:grid;place-items:center;background:#000;color:#fff;font-size:1.28rem}' +
    '@media (prefers-reduced-motion: reduce){.svnty-xs-toast{transition:opacity .2s linear;transform:none}.svnty-xs-toast.is-in,.svnty-xs-toast.is-out{transform:none}}';
  var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

  var bar = document.createElement('div');
  bar.className = 'svnty-xs-bar'; bar.setAttribute('role', 'status'); bar.setAttribute('data-svnty-xs-bar', '');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function render() {
    var x = get(); if (!x) { bar.remove(); document.body.classList.remove('svnty-xs-live'); return; }
    var item = x.item && x.item.title ? esc(x.item.title) : 'your piece';
    if (x.step === 'captured' && x.target) {
      bar.innerHTML = '<span class="svnty-xs-bar__text"><strong>' + esc(x.target.title) + '</strong> chosen for your exchange.</span>' +
        '<a class="svnty-xs-bar__act svnty-xs-bar__act--solid" href="' + DESK + '?xs=' + encodeURIComponent(x.id) + '#rd-order">Back to my exchange</a>';
    } else {
      bar.innerHTML = '<span class="svnty-xs-bar__text">Swapping <strong>' + item + '</strong>. Pick the piece you want, choose its size, then Choose for my exchange.</span>' +
        '<button type="button" class="svnty-xs-bar__act" data-xs-cancel>Cancel swap</button>';
    }
    if (!bar.isConnected) document.body.appendChild(bar);
    document.body.classList.add('svnty-xs-live');
  }
  /* ---------- DOCKING: ride on top of the PDP quick-add bar (.svnty-pdpbar), one motion ----------
     The quick-add bar hides with translateY(110%) when the buy box is in view (its own IntersectionObserver).
     We mirror its transition duration/easing onto our transform so both bars move as one unit, and we
     read its height with a ResizeObserver. Everything is transform-only: no layout writes on scroll. */
  var pdpbar = null, ro = null, mo = null, mq = window.matchMedia('(max-width: 749px)');
  function dockNow() {
    var h = 0;
    if (pdpbar && mq.matches && !pdpbar.classList.contains('is-buybox-visible') && getComputedStyle(pdpbar).display !== 'none') h = pdpbar.getBoundingClientRect().height;
    var cs = pdpbar ? getComputedStyle(pdpbar) : null;
    if (cs && cs.transitionDuration && cs.transitionDuration !== '0s') {
      var tf = (cs.transitionTimingFunction.match(/^(cubic-bezier\([^)]*\)|steps\([^)]*\)|[a-z-]+)/i) || [''])[0];
      bar.style.setProperty('--svp-xs-dock-dur', cs.transitionDuration.split(',')[0].trim());
      if (tf) bar.style.setProperty('--svp-xs-dock-ease', tf);
    }
    document.documentElement.style.setProperty('--svp-xs-dock', Math.round(h) + 'px');
    bar.style.setProperty('--svp-xs-dock', Math.round(h) + 'px');
  }
  var dockRaf = 0; function dock() { if (dockRaf) return; dockRaf = requestAnimationFrame(function () { dockRaf = 0; dockNow(); }); }
  function detachDock() {
    if (ro) ro.disconnect();
    if (mo) mo.disconnect();
    if (mq.removeEventListener) mq.removeEventListener('change', dock); else if (mq.removeListener) mq.removeListener(dock);
    ro = null; mo = null; pdpbar = null;
  }
  function attachDock() {
    detachDock();
    if (!get()) { document.documentElement.style.setProperty('--svp-xs-dock', '0px'); return; }
    pdpbar = document.querySelector('.svnty-pdpbar');
    if (!pdpbar) { document.documentElement.style.setProperty('--svp-xs-dock', '0px'); return; }
    if ('ResizeObserver' in window) { ro = new ResizeObserver(dock); ro.observe(pdpbar); }
    mo = new MutationObserver(dock); mo.observe(pdpbar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    mq.addEventListener ? mq.addEventListener('change', dock) : mq.addListener(dock);
    dock();
  }
  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-xs-cancel]')) { clear(); render(); relabel(false); }
  });

  /* ---------- PDP add-button label ---------- */
  var relabelled = [];
  function relabel(on) {
    if (!on) { relabelled.forEach(function (r) { r.node.nodeValue = r.was; }); relabelled = []; return; }
    var x = get(); if (!x || x.step !== 'browsing') return;
    document.querySelectorAll('product-form-component button[type="submit"], product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"], .svnty-pdpbar [data-svnty-pdpbar-add]').forEach(function (btn) {
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (!/add to (bag|cart)/i.test(t)) continue;
        relabelled.push({ node: node, was: t });
        node.nodeValue = t.replace(/add to (bag|cart)/i, 'Choose for my exchange');
      }
    });
  }

  /* ---------- capture: explicit intent only; the cart is never touched ----------
     On a PDP in swap mode, the product form's submit is intercepted and the selected variant becomes
     the target. No /cart/add, drawer, or add-to-cart analytics event is emitted. */
  /* ---------- in-place confirmation; the customer returns to the desk explicitly ---------- */
  var toastEl = null, toastTimer = null;
  function toastMessage(message) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'svnty-xs-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span class="svnty-xs-toast__check" aria-hidden="true">&#10003;</span><span class="svnty-xs-toast__text">' + esc(message) + '</span>';
    clearTimeout(toastTimer);
    toastEl.classList.remove('is-out'); void toastEl.offsetWidth; toastEl.classList.add('is-in');
    toastTimer = setTimeout(function () { toastEl.classList.add('is-out'); toastEl.classList.remove('is-in'); }, 3200);
  }
  function toast(t) {
    toastMessage(t.title + (t.options ? ' \u00b7 ' + t.options : '') + ' chosen for your exchange');
  }
  function finish(id, rev, t) {
    var current = get();
    if (!current || current.id !== id || Number(current.rev) !== Number(rev)) return;
    current.target = t; current.step = 'captured';
    if (!set(current, rev)) {
      toastMessage('Your browser could not save this exchange choice. Nothing was changed.');
      return;
    }
    render(); relabel(false); toast(t);
  }
  function vimg(v, pj) {
    var fm = v && (v.featured_media || v.featured_image);
    if (fm && fm.preview_image && fm.preview_image.src) return fm.preview_image.src;
    if (fm && fm.src) return fm.src;
    if (typeof fm === 'string') return fm;
    if (pj && pj.featured_image) return typeof pj.featured_image === 'string' ? pj.featured_image : (pj.featured_image.src || '');
    if (pj && pj.featured_media && pj.featured_media.preview_image) return pj.featured_media.preview_image.src || '';
    return '';
  }
  function handleFromPath() { var m = /\/products\/([^\/?#]+)/.exec(location.pathname); return m ? decodeURIComponent(m[1]) : ''; }
  function captureFromForm(form) {
    var idEl = form.querySelector('input[name="id"], select[name="id"]'); var vid = idEl && idEl.value; if (!vid) return false;
    return captureVariant(vid, handleFromPath());
  }
  /* A variant chosen anywhere (a product form, or a cart add the guard stopped on a collection card): its product is the page's
     own on a product page, else Shopify's /variants/<id> redirect names it. */
  function captureVariant(vid, handle) {
    var x = get(); if (!x || x.step !== 'browsing') return false;
    var world = document.body.getAttribute('data-world') || 'original';
    var sessionId = x.id, sessionRev = x.rev;
    var h1 = handle ? document.querySelector('h1') : null; var title = h1 ? h1.textContent.trim() : 'Your chosen piece';
    var base = { variant_id: Number(vid), handle: handle, title: title, options: '', price: null, image: '', world: world, available: null, captured_at: now() };
    var named = handle ? Promise.resolve(handle) : realFetch.call(window, '/variants/' + encodeURIComponent(vid), { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then(function (r) { var m = /\/products\/([^\/?#]+)/.exec(r.url || ''); if (!m) throw new Error('no_product'); handle = decodeURIComponent(m[1]); base.handle = handle; return handle; });
    named.then(fetchProduct)
      .then(function (pj) {
        var v = (pj.variants || []).filter(function (vv) { return String(vv.id) === String(vid); })[0] || {};
        finish(sessionId, sessionRev, { variant_id: Number(vid), product_id: pj.id, handle: pj.handle || handle, title: pj.title || title, options: v.title || '', price: v.price != null ? v.price / 100 : null,
                    image: vimg(v, pj), world: world, available: v.available === true, captured_at: now() });
      })
      .catch(function () { finish(sessionId, sessionRev, base); }); // the desk re-confirms stock and price live
    return true;
  }
  // Horizon's product-form-component acts on the BUTTON click (not only the form submit), so both are
  // intercepted in the capture phase; whichever fires first wins and the other is a no-op.
  function intercept(e, form) { if (captureFromForm(form)) { e.preventDefault(); e.stopImmediatePropagation(); } }
  document.addEventListener('click', function (e) {
    var padd = e.target && e.target.closest && e.target.closest('.svnty-pdpbar [data-svnty-pdpbar-add]');
    if (padd) {
      var host = padd.closest('.svnty-pdpbar'); var x0 = get();
      if (!x0 || x0.step !== 'browsing' || !host || typeof host.resolveVariant !== 'function') return;
      var rv = host.resolveVariant();
      if (!rv || !rv.available) return;               // let the bar prompt for a size / say sold out
      e.preventDefault(); e.stopImmediatePropagation();
      var fake = document.createElement('form'); var inp = document.createElement('input'); inp.name = 'id'; inp.value = String(rv.id); fake.appendChild(inp);
      captureFromForm(fake); return;
    }
    var btn = e.target && e.target.closest && e.target.closest('product-form-component button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form'); if (form) intercept(e, form);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('product-form-component') && !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    intercept(e, form);
  }, true);

  // Collection/search quick-shop emits the same explicit exchange intent without touching the cart.
  document.addEventListener('svnty:exchange-pick', function (e) {
    var x = get();
    if (!x || x.step !== 'browsing') return;
    var t = e.detail || {};
    var price = typeof t.price === 'string' ? Number(String(t.price).replace(/[^0-9.]/g, '')) : t.price;
    finish(x.id, x.rev, {
      variant_id: Number(t.variant_id), product_id: t.product_id, handle: String(t.handle || ''),
      title: String(t.title || ''), options: String(t.options || ''), price: price,
      image: String(t.image || ''), world: 'original',
      available: t.available === true, captured_at: now()
    });
  });

  /* Buy-it-now is a checkout shortcut: hidden while a swap is being chosen (an exchange is never a purchase). */
  function hideBuyNow(on) {
    document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"], buy-buttons-component .shopify-payment-button').forEach(function (el) { el.hidden = !!on; });
  }
  var _render = render;
  render = function () { _render(); var x = get(); hideBuyNow(!!x && x.step === 'browsing'); };
  render(); relabel(true); attachDock();
  // Injected by the theme.liquid bootstrap, so DOMContentLoaded may already be gone (L-01).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { relabel(true); if (!pdpbar) attachDock(); });
  setTimeout(function () { if (!pdpbar) attachDock(); }, 800);   // the sticky bar upgrades late on slow loads
  window.addEventListener('pageshow', function () {
    render(); relabel(false); relabel(true); attachDock();
  });
  window.addEventListener('pagehide', function () {
    hideBuyNow(false); detachDock();
  });
  window.addEventListener('storage', function (e) {
    if (isActiveStorageKey(e.key)) { render(); relabel(false); relabel(true); }
  });
})();
